import type { ComponentType } from 'react'
import { AnimatePresence } from 'motion/react'
import { useNavigation } from '@/contexts/NavigationProvider'
import { useAppShortcuts } from '@/hooks/useAppShortcuts'
import type { ScreenId } from '@/types/game'
import { BootScreen } from '@/components/screens/BootScreen'
import { HomeScreen } from '@/components/screens/HomeScreen'
import { WorldMapScreen } from '@/components/screens/WorldMapScreen'
import { GameScreen } from '@/components/screens/GameScreen'
import { LevelCompleteScreen } from '@/components/screens/LevelCompleteScreen'
import { GameOverScreen } from '@/components/screens/GameOverScreen'
import { NoLivesScreen } from '@/components/screens/NoLivesScreen'
import { PauseScreen } from '@/components/screens/PauseScreen'
import { ShopScreen } from '@/components/screens/ShopScreen'
import { CharactersScreen } from '@/components/screens/CharactersScreen'
import { ProfileScreen } from '@/components/screens/ProfileScreen'
import { LeaderboardScreen } from '@/components/screens/LeaderboardScreen'
import { SettingsScreen } from '@/components/screens/SettingsScreen'
import { EndlessScreen } from '@/components/screens/EndlessScreen'
import { HelpScreen } from '@/components/screens/HelpScreen'
import { CreditsScreen } from '@/components/screens/CreditsScreen'
import { DailyRewardScreen } from '@/components/screens/DailyRewardScreen'
import { BottomNav } from '@/components/ui/BottomNav'

const NAV_SCREENS: ScreenId[] = ['home', 'map', 'shop', 'characters', 'profile', 'leaderboard', 'settings', 'endless', 'help', 'credits', 'daily']

const SCREENS: Record<Exclude<ScreenId, 'pause' | 'tutorial'>, ComponentType> = {
  boot: BootScreen,
  home: HomeScreen,
  map: WorldMapScreen,
  game: GameScreen,
  'level-complete': LevelCompleteScreen,
  'game-over': GameOverScreen,
  'no-lives': NoLivesScreen,
  shop: ShopScreen,
  characters: CharactersScreen,
  profile: ProfileScreen,
  leaderboard: LeaderboardScreen,
  settings: SettingsScreen,
  endless: EndlessScreen,
  help: HelpScreen,
  credits: CreditsScreen,
  daily: DailyRewardScreen,
}

export default function App() {
  const { screen, canGoBack, back } = useNavigation()
  useAppShortcuts({ screen, canGoBack, back })

  const key = screen === 'pause' ? 'game' : screen
  const Screen = SCREENS[key as Exclude<ScreenId, 'pause' | 'tutorial'>] ?? HomeScreen

  return (
    <div className="app-shell">
      <AnimatePresence mode="wait">
        <div key={key} className="flex-1 min-h-0">
          <Screen />
        </div>
      </AnimatePresence>
      {NAV_SCREENS.includes(screen) && <BottomNav />}
      {screen === 'pause' && <PauseScreen />}
    </div>
  )
}
